// Libraries
import { useFormik } from "formik";
import * as Yup from "yup";

// Constants
import { checkboxFields } from "../../constants/BookingConstants";

// Validation for front formik.
const checkboxSchema = checkboxFields.reduce((acc, field) => {
  acc[field] = Yup.boolean().when("joinWaitlist", {
    is: false,
    then: (schema) => schema.oneOf([true], "Required"),
    otherwise: (schema) => schema.notRequired(),
  });
  return acc;
}, {});

const validationSchema = Yup.object().shape({
  reason: Yup.string().required("Required"),
  date: Yup.string().required("Required"),
  joinWaitlist: Yup.boolean().required(),
  available: Yup.object().when("joinWaitlist", {
    is: false,
    then: (schema) => schema.required("Required"),
    otherwise: (schema) => schema.optional(),
  }),
  notes: Yup.string().required("Required"),
  ...checkboxSchema,
});

const checkboxInitialValues = checkboxFields.reduce((acc, field) => {
  acc[field] = false;
  return acc;
}, {});

export const useBookingFormik = (handleOpenConfirm) => {
  return useFormik({
    initialValues: {
      reason: "Online booking",
      date: "",
      available: "",
      notes: "",
      joinWaitlist: false,
      ...checkboxInitialValues,
    },
    validationSchema: validationSchema,

    onSubmit: async (values) => {
      handleOpenConfirm(values);
    },
  });
};
